var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="profile-cal__time-listing-container show-more cf"> ';
 $.each(cal.sortEvents(events), function (day, events) { ;
__p += ' <ul class="profile-cal__time-listing"> ';
 $.each(events, function (index, event) { ;
__p += ' ' +
((__t = ( cal._event(event) )) == null ? '' : __t) +
' ';
 }); ;
__p += ' </ul> ';
 }); ;
__p += ' </div>';

}
return __p
};

/*
original source:

<div class="profile-cal__time-listing-container show-more cf">
    <% $.each(cal.sortEvents(events), function (day, events) { %>
        <ul class="profile-cal__time-listing">
            <% $.each(events, function (index, event) { %>
                <%= cal._event(event) %>
            <% }); %>
        </ul>
    <% }); %>
</div> <!-- .profile-cal__time-listing-container -->

*/
